import { pathWithParams } from 'utils/url';

type ImportedListingSource =
  | 'DONORS_CHOOSE'
  | 'KIVA'
  | 'NYCPARKS'
  | 'GLOBAL_GIVING'
  | 'VOLUNTEERMATCH'
  | 'VOLUNTEERGOV'
  | 'MOVE_ON'
  | 'POINTS_OF_LIGHT'
  | 'AARP'
  | 'DO_SOMETHING'
  | 'NEWYORKCARES';

export const getImportedListingUrl = (
  url: string,
  source: ImportedListingSource
) =>
  source && source === 'DO_SOMETHING'
    ? pathWithParams(url, {
        utm_medium: 'referral',
        utm_source: 'partner',
        utm_campaign: 'idealist_vcredit',
        utm_content: 'vcredit',
      })
    : pathWithParams(url, {
        utm_medium: 'referral',
        utm_source: 'idealist',
        utm_campaign: 'action_opportunities',
      });
